import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import React from 'react';
import AkSpinner from '@atlaskit/spinner';
import { messages } from '@atlaskit/media-ui';
import { useIntl } from 'react-intl-next';
export var Spinner = function Spinner(_ref) {
  _objectDestructuringEmpty(_ref);
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(AkSpinner, {
    label: intl.formatMessage(messages.loading_file),
    appearance: "invert",
    size: "large"
  });
};